import React, { createContext, useState, useContext } from 'react';

type FiltersContextState = {
  setDashAcessosFilter: React.Dispatch<React.SetStateAction<string>>;
  setDashDiagnosticosFilter: React.Dispatch<React.SetStateAction<string>>;
  setDashRegistroSasFilter: React.Dispatch<React.SetStateAction<string>>;
  setDashAtendSseFilter: React.Dispatch<React.SetStateAction<string>>;
  setDashUsuariosFilter: React.Dispatch<React.SetStateAction<string>>;
  dashAcessosFilter: string;
  dashDiagnosticosFilter: string;
  dashRegistroSasFilter: string;
  dashAtendSseFilter: string;
  dashUsuariosFilter: string;
};

const FiltersContext = createContext<FiltersContextState | null>(null);

type FiltersProviderProps = {
  children?: React.ReactNode;
};

export const FiltersProvider = ({ children }: FiltersProviderProps) => {
  const [dashAcessosFilter, setDashAcessosFilter] = useState<string>('total');
  const [dashDiagnosticosFilter, setDashDiagnosticosFilter] =
    useState<string>('');
  const [dashRegistroSasFilter, setDashRegistroSasFilter] =
    useState<string>('registros-sas');
  const [dashAtendSseFilter, setDashAtendSseFilter] = useState<string>('total');
  const [dashUsuariosFilter, setDashUsuariosFilter] = useState<string>('total');

  return (
    <FiltersContext.Provider
      value={{
        setDashAcessosFilter,
        setDashDiagnosticosFilter,
        setDashRegistroSasFilter,
        setDashAtendSseFilter,
        setDashUsuariosFilter,
        dashAcessosFilter,
        dashDiagnosticosFilter,
        dashRegistroSasFilter,
        dashAtendSseFilter,
        dashUsuariosFilter,
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
};

export const useFilters = (): FiltersContextState => {
  const context = useContext(FiltersContext);

  if (context === null) {
    throw new Error(`useFilters must be used within a FiltersProvider`);
  }

  return context;
};
